import { render, staticRenderFns } from "./FileUploadSettings.vue?vue&type=template&id=4648fb0e&scoped=true"
import script from "./FileUploadSettings.vue?vue&type=script&lang=js"
export * from "./FileUploadSettings.vue?vue&type=script&lang=js"
import style0 from "./FileUploadSettings.vue?vue&type=style&index=0&id=4648fb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648fb0e",
  null
  
)

export default component.exports